import React from "react";
import { Link } from "react-router-dom";
import "../../styles/product/CategoryCard.css";
import { CategorySummary } from "../../types/store";
import { getCategoryCoverImage, getCategoryKey } from "../../utils/categoryImages";

interface CategoryCardProps {
  category: CategorySummary;
  selected?: boolean;
  onClick?: () => void;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ category, selected = false, onClick }) => {
  const categoryKey = getCategoryKey(category);
  const categoryTarget = category.slug ?? category.name;
  const categoryImage = getCategoryCoverImage(category);
  const categoryName = category.name.trim();
  const categoryItemClassName =
    categoryKey === "appliances"
      ? "category-card__item category-card__item--appliances"
      : "category-card__item";
  const categoryParams = new URLSearchParams({
    discover: "1",
    view: "collection",
    category: categoryTarget,
    title: category.name,
  });
  const cardClassName = ["category-card", selected ? "is-selected" : ""].filter(Boolean).join(" ");

  return (
    <div className={categoryItemClassName}>
      {onClick ? (
        <button type="button" className={cardClassName} onClick={onClick}>
          <div className="category-card__media">
            {categoryImage ? <img src={categoryImage} alt={category.name} className="category-card__image" /> : null}
          </div>
          <div className="category-card__content">
            <h3 className="category-card__title">{categoryName}</h3>
          </div>
        </button>
      ) : (
        <Link
          className={cardClassName}
          to={categoryKey === "services" ? "/services" : `/products?${categoryParams.toString()}`}
        >
          <div className="category-card__media">
            {categoryImage ? <img src={categoryImage} alt={category.name} className="category-card__image" /> : null}
          </div>
          <div className="category-card__content">
            <h3 className="category-card__title">{categoryName}</h3>
          </div>
        </Link>
      )}
    </div>
  );
};

export default CategoryCard;
